module.exports = __webpack_public_path__ + "eb401c1ed739f72a3aff937558c7b1e8.svg";